import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation } from 'react-router-dom';
import { decryptText } from '../../utils/encryption';
import OutstandingLedger from './OutstandingLedger';

const ALLOWED_TOKEN = 'NABLHFHDSGDCJ5678DHFKJG';

const OutstandingLedgerStandalone = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authorized, setAuthorized] = useState(null); // null = checking

  useEffect(() => {
    const encryptedUsername = new URLSearchParams(location.search).get('username') || '';
    const decrypted = encryptedUsername ? decryptText(encryptedUsername) : '';

    if (decrypted === ALLOWED_TOKEN) {
      setAuthorized(true);
    } else {
      setAuthorized(false);
      localStorage.clear();
      sessionStorage.clear();
    window.location.href = 'https://nablwp.qci.org.in/Home/login';
    }
  }, [location.search, navigate]);

  if (authorized === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!authorized) return null;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'white' }}>
      <Box sx={{ px: 3, pt: 3 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ color: '#00024c' }}
        >
          Back
        </Button>
      </Box>
      <OutstandingLedger />
    </Box>
  );
};

export default OutstandingLedgerStandalone;